var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2645",
    "data-name": "\\uC0AC\\uAC01\\uD615 2645",
    width: 24,
    height: 24,
    transform: "translate(122 465)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_16",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 16",
    transform: "translate(-122 -465)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4256",
    "data-name": "\\uADF8\\uB8F9 4256",
    transform: "translate(121 469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4259",
    "data-name": "\\uADF8\\uB8F9 4259",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3001",
    "data-name": "\\uD328\\uC2A4 3001",
    d: "M10.513.75l5.679,5.679-5.679,5.68",
    transform: "translate(-0.854 1.571)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3002",
    "data-name": "\\uD328\\uC2A4 3002",
    d: "M12.391,0",
    transform: "translate(2.546 8)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkGrey);
export default __webpack_public_path__ + "static/media/iconLinkGrey.47286e7c35836485b0766f1ed7d4e0b8.svg";
export { ForwardRef as ReactComponent };